// extracted by mini-css-extract-plugin
export default {"data-table":"ExpandableTable_data-table__ggmIN"};